import React, { useState } from "react";
import "./changePassword.css";
import { useNavigate } from "react-router-dom";
import Header from "../../components/header";
import { ThreeDot } from "react-loading-indicators";
import MobileHeader from "../../components/MobileHeader";
import { useMediaQuery } from "react-responsive";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const BASE_URL = process.env.REACT_APP_BASE_URL;

function ChangePasswordPage() {
  const navigate = useNavigate();
  const [old_password, setOld_Password] = useState("");
  const [new_password, setNew_Password] = useState("");
  const [confirm_password, setConfirm_Password] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [loading, setLoading] = useState(false);

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    const token = localStorage.getItem("access_token");
    if (!token) {
      setError("Authentication token not found. Please login again.");
      return;
    }

    if (!old_password || !new_password || !confirm_password) {
      setError("All fields are required.");
      return;
    }

    if (new_password.length < 6) {
      setError("New password must be at least 6 characters long.");
      return;
    }

    const passwordRegex = /^(?=.*[A-Z])(?=.*[!@#$%^&*])/;
    if (new_password.length < 6 || !passwordRegex.test(new_password)) {
      setError(
        "Password must be at least 6 characters long, include at least one uppercase letter and one special character."
      );
      setLoading(false);
      return;
    }

    if (new_password !== confirm_password) {
      setError("New password and confirm password do not match.");
      return;
    }

    try {
      setLoading(true);
      const response = await fetch(`${BASE_URL}/user/reset-password/`, {
        method: "POST",
       headers: { "Content-Type": "application/json",Authorization: `Bearer ${token}`,"x-api-key": process.env.REACT_APP_X_API_KEY },

        body: JSON.stringify({
          old_password,
          new_password,
          confirm_password,
        }),
      });
      console.log("Token being used:", token);
      console.log("Payload:", {
        old_password,
        new_password,
        confirm_password,
      });
      const data = await response.json();

      if (!response.ok) {
        console.error("Server Response:", data);
        setError(data.detail || data.message || "Failed to change password.");
        return;
      }

      setMessage("Password changed successfully!");
      setOld_Password("");
      setNew_Password("");
      setConfirm_Password("");
      setTimeout(() => {
        navigate("/profile-view");
      }, 1500);
    } catch (err) {
      console.error("Network Error:", err);
      setError("Could not connect to server.");
    } finally {
      setLoading(false);
    }
  };
 const renderPasswordInput = (value, setValue, placeholder, show, setShow) => (
  <div className="relative">
    <input
      type={show ? "text" : "password"}
      placeholder={placeholder}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      autoComplete={
        placeholder.toLowerCase().includes("old")
          ? "current-password"
          : "new-password"
      }
      className="w-full px-4 py-3.5 text-gray-900 rounded-xl border border-gray-300 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#0f6abf]/30 focus:border-[#0f6abf] transition-all pr-12"
    />

    {/* Eye Icon Button */}
    <button
      type="button"
      className="absolute right-3 top-1/2 -translate-y-1/2 p-2 text-gray-400 hover:text-gray-600 transition-colors"
      onClick={() => setShow(!show)}
      tabIndex={-1}
    >
      {show ? (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L6.59 6.59m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
        </svg>
      ) : (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
        </svg>
      )}
    </button>
  </div>
);


  return (
    // <>
    //   {isMobile ? (
    //     <MobileHeader hideFilter={true} hideHamburger={true} />
    //   ) : (
    //     <Header hideFilter={true} />
    //   )}{" "}
    //   <div className="login-container forgot_pass">
    //     <div className="signin-details-container">
    //       <form className="signin-form" onSubmit={handleChangePassword}>
    //         <h2>Change Password</h2>
    //         {renderPasswordInput(
    //           old_password,
    //           setOld_Password,
    //           "Old Password",
    //           showOldPassword,
    //           setShowOldPassword
    //         )}
    //         {renderPasswordInput(
    //           new_password,
    //           setNew_Password,
    //           "New Password",
    //           showNewPassword,
    //           setShowNewPassword
    //         )}
    //         {renderPasswordInput(
    //           confirm_password,
    //           setConfirm_Password,
    //           "Confirm New Password",
    //           showConfirmPassword,
    //           setShowConfirmPassword
    //         )}
    //         {error && <p className="error-message">{error}</p>}
    //         {message && <p className="success-message">{message}</p>}
    //         <div className="btn-container">
    //           <button type="submit" className="signin-button">
    //             {loading ? (
    //               <ThreeDot color={["#ffffff"]} size="small" />
    //             ) : (
    //               "Save"
    //             )}{" "}
    //           </button>
    //         </div>
    //       </form>
    //     </div>
    //   </div>
    // </>
    <>
  {isMobile ? (
    <MobileHeader hideFilter={true} hideHamburger={true} />
  ) : (
    <Header hideFilter={true} />
  )}
  
  <div className="flex items-center justify-center bg-[#F9F7F4] p-4">
    <div className="w-full max-w-md">
      {/* Card Header */}
      <div className="text-center mb-8">
        <div className="w-16 h-16 bg-[#e8f0f7] rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
          </svg>
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Change Password</h2>
        <p className="text-gray-500 text-sm">Update your account password</p>
      </div>

      {/* Card */}
      <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
        <form onSubmit={handleChangePassword} className="space-y-5">
          {/* Password Inputs */}
          <div className="space-y-4">
            {renderPasswordInput(
              old_password,
              setOld_Password,
              "Current Password",
              showOldPassword,
              setShowOldPassword
            )}
            
            {renderPasswordInput(
              new_password,
              setNew_Password,
              "New Password",
              showNewPassword,
              setShowNewPassword
            )}
            
            {renderPasswordInput(
              confirm_password,
              setConfirm_Password,
              "Confirm New Password",
              showConfirmPassword,
              setShowConfirmPassword
            )}
          </div>

          {/* Messages */}
          <div className="space-y-3">
            {error && (
              <div className="flex items-center gap-2 p-3 bg-red-50 text-red-600 rounded-lg">
                <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span className="text-sm">{error}</span>
              </div>
            )}
            
            {message && (
              <div className="flex items-center gap-2 p-3 bg-green-50 text-green-600 rounded-lg">
                <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span className="text-sm">{message}</span>
              </div>
            )}
          </div>

          {/* Submit Button */}
          <div className="pt-2">
            <button
              type="submit"
              disabled={loading}
              className={`w-full py-3 px-4 rounded-xl font-medium transition-all duration-200 ${
                loading
                  ? 'bg-gray-300 cursor-not-allowed'
                  : 'bg-[#0f6abf] text-white hover:bg-[#0a5ca8] active:scale-[0.98]'
              }`}
            >
              {loading ? (
                <div className="flex items-center justify-center gap-2">
                  <ThreeDot color={["#ffffff"]} size="small" />
                  <span>Updating...</span>
                </div>
              ) : (
                <div className="flex items-center justify-center gap-2">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Save Changes</span>
                </div>
              )}
            </button>
          </div>

          {/* Password Tips */}
          <div className="pt-4 border-t border-gray-100">
            <p className="text-xs text-gray-500 text-center">
              Make sure your new password is at least 8 characters long and includes numbers and symbols
            </p>
          </div>
        </form>
      </div>
    </div>
  </div>
</>
  );
}

export default ChangePasswordPage;
